import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import ReactToPrint from "react-to-print";
import { DeleteOutlined } from "@ant-design/icons";
import dateFormat from "dateformat";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import moment from "moment";
import {
  updateInvoice,
  getInvoiceItem,
  getServices,
  updateInvoiceItem,
  deleteInvoiceItem,
  getSpecificInvoice,
  updateService,
  deleteService,
  sendDispatchSms,
} from "../../../../actions/invoiceItem";
import { getdeliverytype } from "../../../../actions/settings";
import { updateVariation } from "../../../../actions/variableProductAction";
import EditMeasurement from "./EditMeasurement";
import {
  getSpecificContact,
  updateContact,
} from "../../../../actions/contactAction";
import { getAllAccount } from "../../../../actions/accountsAction";
import { getInvoiceMeasurement } from "../../../../actions/measurment";
import { getSpecificMeasurementbycontact } from "../../../../actions/measurment";


import Addtoupdate from "../../Addtoupdate";
import AddService from "./AddServiceToUpdate";
import Addpackagingtoupdate from "../../Addpackagingtoupdate";
import Log from "./Log";
import {
  Form,
  Input,
  InputNumber,
  Checkbox,
  Button,
  Col,
  Row,
  Select,
  message,
  TreeSelect,
  Space,
  Divider,
  Drawer,
  Image,
  Skeleton,
  DatePicker,
  Spin,
  Modal
} from "antd";
import { values } from "@antv/util";

const { Option } = Select;

const Quickview = ({
  invoice,
  updateInvoice,
  getInvoiceItem,
  getServices,
  updateVariation,
  updateInvoiceItem,
  deleteInvoiceItem,
  getdeliverytype,
  getAllAccount,
  courier,
  getSpecificInvoice,
  updateService,
  deleteService,
  getInvoiceMeasurement,
  getSpecificMeasurementbycontact,
  sendDispatchSms,
  getAllEmployee,
  auth,
}) => {
  var formatter = new Intl.NumberFormat("en-IN");
  const [visible, setVisible] = useState(false);
  const [loading, setloading] = useState(true);
  const [fullpageloading, setfullpageloading] = useState(false);
  const [accounts, setaccounts] = useState([]);
  const [measurements, setmeasurements] = useState([]);
  const [initialmeasurements, setinitialmeasurements] = useState({});
  const packagingItems = useRef([]);
  const bill = useRef();
  const [cart, setcart] = useState(false);
  const [refresh, setrefresh] = useState(false);
  const [data, setdata] = useState();
  const [services, setservices] = useState();
  const [deliverymethod, setdeliverymethod] = useState([]);
  const [form] = Form.useForm();
  const loaddata = useRef(false);
  const initialdata = useRef();
  const [originalStatus, setOriginalStatus] = useState(""); 
  const [isStatusOpen, setIsStatusOpen] = useState(true);


  // Local state for spec_discount management
  const [itemDiscounts, setItemDiscounts] = useState({});
  
  let details = {};
  const Wallet = useRef({
    Bill: 0,
    Due: 0,
    Payment: 0,
    Advance: 0,
    PaymentMethod: 0,
    VAT: 0,
    Discount: 0,
    Cupon: null,
    DiscountLimit: 300,
    Quantity: 0,
  });

  // Calculate total spec_item_discount from all items
  const calculateTotalSpecDiscount = () => {
    return Object.values(itemDiscounts).reduce((total, discount) => {
      return total + (parseFloat(discount) || 0);
    }, 0);
  };

  // Update the form field when itemDiscounts change
  useEffect(() => {
    const totalSpecDiscount = calculateTotalSpecDiscount();
    form.setFieldsValue({ spec_item_discount: totalSpecDiscount });
  }, [itemDiscounts, form]);

  useEffect(() => {
    if (visible) {
      getdeliverytype().then((delivery) => {
        setdeliverymethod(delivery);
      });
      getAllAccount().then((acc) => {
        setaccounts(acc);
      });

      getSpecificInvoice(invoice.id).then((result) => {
        getSpecificMeasurementbycontact(result.contact.id).then((res) => {
          if (typeof res != "undefined") {
            setinitialmeasurements(res);
          }
        });
        if (result.delivery_date != null && result.delivery_date != undefined) {
          result.delivery_date = moment(result.delivery_date);
        }
        if (result.dispatch_date != null && result.dispatch_date != undefined) {
          result.dispatch_date = moment(result.dispatch_date);
        }
        if (result.issue_date != null && result.issue_date != undefined) {
          result.issue_date = moment(result.issue_date);
        }

        form.setFieldsValue({
          ...result,
          Account_no: result.Account_no || "",
          Transection_no: result.Transection_no || "",
        });
        initialdata.current = result;
        details = { ...result };
        console.log(details);
        Wallet.current.Bill = details.bill;
        Wallet.current.Due = details.due;
        Wallet.current.Payment = details.payment;
        Wallet.current.Discount = parseFloat(details.discount) + parseFloat(details.additional_discount) + parseFloat(details.spec_item_discount);
        Wallet.current.DiscountLimit = details.discountlimit;
        Wallet.current.VAT = details.tax;
        Wallet.current.Advance = details.advance_payment;
        Wallet.current.Cupon = details.cupon;
        Wallet.current.Quantity = details.quantity;
        bill.current = 0;
        
        setOriginalStatus(result.status);
        
        getInvoiceMeasurement(invoice.id).then((response) => {
          setmeasurements(response);
          getInvoiceItem(invoice.id).then((items) => {
            getServices(invoice.id).then((services) => {
              setdata(items);
              setservices(services);
              
              // Initialize itemDiscounts with existing spec_discount values
              const discounts = {};
              items.forEach(item => {
                discounts[item.id] = item.spec_discount || 0;
              });
              setItemDiscounts(discounts);
              
              setloading(false);
            });
          });
        });

        setrefresh(false);
      });
    }
  }, [refresh, visible]);

  // Handle spec_discount change
  const handleSpecDiscountChange = (itemId, value) => {
    setItemDiscounts(prev => ({
      ...prev,
      [itemId]: value || 0
    }));
  };

  // Calculate display price based on discount
  const getDisplayPrice = (item) => {
    const discount = itemDiscounts[item.id] || 0;
    const originalPrice = parseFloat(item.price) || 0;
    return Math.max(0, originalPrice - discount);
  };

  const onFinish = (values) => {
    if (values.status === originalStatus) {
      Modal.confirm({
        title: 'Status Not Changed',
        content: 'You have not changed the status from the original value. Do you want to continue with the update?',
        okText: 'Yes, Update Anyway',
        cancelText: 'No, Let me change',
        onOk: () => {
          proceedWithUpdate(values);
        },
        onCancel: () => {
          setIsStatusOpen(true);
          return false;
        },
      });
    } else {
      proceedWithUpdate(values);
    }
  };

  const proceedWithUpdate = async (values) => {
    setfullpageloading(true);
    
    try {
      // First, update all item discounts
      const updatePromises = data.map(item => {
        const newDiscount = itemDiscounts[item.id] || 0;
        const originalDiscount = item.spec_discount || 0;
        
        // Only update if discount has changed
        if (newDiscount !== originalDiscount) {
          let formData = new FormData();
          formData.append("spec_discount", newDiscount);
          formData.append("data", "");
          return updateInvoiceItem(item.id, formData);
        }
        return Promise.resolve();
      });

      // Wait for all item updates to complete
      await Promise.all(updatePromises);

      // Calculate total spec_item_discount from all items
      const totalSpecDiscount = calculateTotalSpecDiscount();
      
      // Set the calculated total to the form values
      values.spec_item_discount = totalSpecDiscount;

      console.log(values);
      if (values.delivery_date != null && values.delivery_date != undefined) {
        values.delivery_date = values.delivery_date.format("YYYY-MM-DD");
      }
      if (values.dispatch_date != null && values.dispatch_date != undefined) {
        values.dispatch_date = values.dispatch_date.format("YYYY-MM-DD");
      }
      if (values.issue_date != null && values.issue_date != undefined) {
        values.issue_date = values.issue_date.format("YYYY-MM-DD");
      }

      if (values.paymentt > 0) {
        values.payment =
          parseFloat(Wallet.current.Payment) + parseFloat(values.paymentt);
        values.due = parseFloat(Wallet.current.Due) - parseFloat(values.paymentt);
      }
      if (values.account == 1) {
        values.Payment_method = "Cash";
      } else {
        for (let i = 0; i < accounts.length; i++) {
          if (accounts[i].id == values.account) {
            values.Payment_method = accounts[i].type;
          }
        }
      }

      console.log("Updating invoice with spec_item_discount:", totalSpecDiscount);
      const result = await updateInvoice(invoice.id, values);
      
      if (result) {
        message.success(`Order updated successfully. Total Product Discount: ${formatter.format(totalSpecDiscount)} BDT`);
        setfullpageloading(false);
        setVisible(false);
        form.resetFields();
        window.location.reload();
      } else {
        setfullpageloading(false);
        message.error("Failed to update order");
      }
    } catch (error) {
      console.error("Error updating order:", error);
      setfullpageloading(false);
      message.error("Failed to update order");
    }
  };

  const handleStatusChange = (value) => {
    if (value === "Cancelled") {
      Modal.confirm({
        title: "Are you sure?",
        content: "Do you really want to cancel this invoice? This action cannot be undone. It will remove All Payment Data After SUBMIT",
        okText: "Yes",
        cancelText: "No",
        onOk: () => {
          form.setFieldsValue({ status: "Cancelled" });
        },
        onCancel: () => {
          form.setFieldsValue({ status: initialdata.current.status });
        },
      });
    } else {
      form.setFieldsValue({ status: value });
    }
  };

  const handleValuesChange = (changedValues, allValues) => {
    if (changedValues.dispatch_order === true) {
      if (!allValues.dispatch_date) {
        form.setFieldsValue({ dispatch_date: moment() });
      }
      form.setFieldsValue({ dispatched_by: auth.profile.title });
    }
  };

  const showDrawer = () => {
    setVisible(true);
    form.resetFields();
    setOriginalStatus(invoice.status || "");
  };

  const onClose = () => {
    form.resetFields();
    setVisible(false);
    setIsStatusOpen(true);
  };

  const handleStatusDropdownVisibleChange = (open) => {
    setIsStatusOpen(open);
  };


  const handleSendSms = async () => {
    setfullpageloading(true);
    let values = {
      dispatch_order: form.getFieldValue("dispatch_order"),
      DeliveryType: form.getFieldValue("DeliveryType"),
      dispatch_date: form.getFieldValue("dispatch_date"),
      dispatched_by: form.getFieldValue("dispatched_by"),   
    };

    if (values.dispatch_date) {
      values.dispatch_date = values.dispatch_date.format("YYYY-MM-DD");
    } else if (values.dispatch_order && values.DeliveryType) {
      values.dispatch_date = moment().format("YYYY-MM-DD");
    }

    const result = await sendDispatchSms(invoice.id, values);
    if (result) {
      setrefresh(true);
    }
    setfullpageloading(false);
  };

  const QuantityUpdate = (value, data) => {
    console.log("on page load");
    let diff = data.quantity - value;
    let mainproduct = data.Product[0].quantity + diff;
    console.log("wordrobe : " + value + " main stock : " + mainproduct);
    let formData = new FormData();
    formData.append("quantity", value);
    formData.append("data", "");
    updateInvoiceItem(data.id, formData);
    formData = new FormData();
    formData.append("quantity", mainproduct);
    formData.append("data", "");
    updateVariation(data.Product[0].id, formData).then((e) => {
      setloading(true);
      setrefresh(true);
    });
  };

  const ServiceUpdate = (quantity, price, data) => {
    let formData = new FormData();
    formData.append("quantity", quantity);
    formData.append("price", price);
    formData.append("data", "");
    updateService(data.id, formData).then((e) => {
      setloading(true);
      setrefresh(true);
    });
  };

  const renderitems = () => {
    if (loading) {
      return <Skeleton active />;
    } else {
      return data.map((item, index) => {
        const displayPrice = getDisplayPrice(item);
        return (
          <>
            <Row
              key={item.id}
              style={{
                borderRadius: "5px",
                padding: "10px",
                border: "1px solid gray",
                marginBottom: "5px",
              }}
            >
              <Col span={8} style={{ margin: "auto" }}>
                {index + 1}. {item.Details}{" "}
              </Col>
              <Col span={4}>
                {item.Product ? (
                  <InputNumber
                    min={1}
                    value={item.quantity}
                    defaultValue={item.quantity}
                    max={item.quantity + item.Product[0].quantity}
                    onChange={(value) => {
                      if (value != null) {
                        QuantityUpdate(value, item);
                      }
                    }}
                  />
                ) : (
                  item.quantity
                )}
              </Col>
              <Col span={5} offset={1}>
                <InputNumber 
                  disabled
                  value={itemDiscounts[item.id] || 0}
                  min={0}
                  max={parseFloat(item.price) || 0}
                  onChange={(value) => handleSpecDiscountChange(item.id, value)}
                  placeholder="Discount"
                  style={{ width: '100%' }}
                />
              </Col>
              <Col span={5} style={{ textAlign: "center", margin: "auto" }}>
                <div>
                  {itemDiscounts[item.id] > 0 && (
                    <div style={{ textDecoration: 'line-through', color: '#999', fontSize: '12px' }}>
                      {formatter.format(item.price)}
                    </div>
                  )}
                  <div style={{ fontWeight: itemDiscounts[item.id] > 0 ? 'bold' : 'normal', color: itemDiscounts[item.id] > 0 ? '#000000ff' : 'inherit' }}>
                    {formatter.format(displayPrice)}
                  </div>
                </div>
              </Col>
              <Col span={1} style={{ textAlign: "center", margin: "auto" }}>
                {item.Product ? (
                  <DeleteOutlined
                    style={{ color: "Red", float: "right", marginTop: "4px" }}
                    onClick={(e) => {
                      let formData = new FormData();
                      let mainproduct =
                        item.Product[0].quantity + item.quantity;
                      formData.append("quantity", mainproduct);
                      formData.append("data", "");
                      updateVariation(item.Product[0].id, formData);
                      deleteInvoiceItem(item.id).then((rsult) => {
                        setloading(true);
                        setrefresh(true);
                      });
                    }}
                  />
                ) : (
                  ""
                )}
              </Col>          
              <Divider style={{marginTop:"5px", marginBottom:"5px",}}></Divider>              
              <b>Stock Order Location:  </b> <text style={{color:"green", marginLeft:"5px"}}> {item.product.Warehouse_name}</text>
            </Row>
          </>
        );
      });
    }
  };

  const renderServiceitems = () => {
    if (loading) {
      return <Skeleton active />;
    } else {
      return services.map((data, index) => {
        if (data.product < 1) {
          return (
            <>
              <Row
                style={{
                  borderRadius: "5px",
                  padding: "10px",
                  border: "1px solid gray",
                  marginBottom: "5px",
                }}
              >
                <Col span={14} style={{ margin: "auto" }}>
                  <div
                    className="d-div"
                    dangerouslySetInnerHTML={{ __html: data.details }}
                  ></div>
                </Col>
                <Col span={4} style={{ textAlign: "center", margin: "auto" }}>
                  <InputNumber
                    min={1}
                    defaultValue={data.quantity}
                    onChange={(value) => {
                      if (value != null) {
                        ServiceUpdate(value, data.price, data);
                      }
                    }}
                  />
                </Col>
                <Col span={4} style={{ textAlign: "center", margin: "auto" }}>
                  <InputNumber
                    style={{ width: "80%" }}
                    min={0}
                    defaultValue={data.price}
                    onChange={(value) => {
                      if (value != null) {
                        ServiceUpdate(data.quantity, value, data);
                      }
                    }}
                  />
                </Col>
                <Col span={1} style={{ textAlign: "center", margin: "auto" }}>
                  <DeleteOutlined
                    style={{ color: "Red", float: "right", marginTop: "4px" }}
                    onClick={(e) => {
                      deleteService(data.id).then((rsult) => {
                        setloading(true);
                        setrefresh(true);
                      });
                    }}
                  />
                </Col>
                <Col span={24}>
                  {/* Measurement code remains the same */}
                </Col>
              </Row>
            </>
          );
        }
      });
    }
  };

  const renderData = () => {
    if (loading) {
      return <Skeleton active />;
    } else {
      const totalSpecDiscount = calculateTotalSpecDiscount();
      
      return (
        <>
          <Row>
            <Col span={24}>
              <Row>
                <Col span={3}>
                  <h3>Invoice No.</h3>
                  {initialdata.current.invoice_number}
                </Col>
                <Col span={3}>
                  <h3>Sales Person</h3>
                  {initialdata.current.Sales_person_name || "-"}
                </Col>
                <Col span={3}>
                  <h3>Issue date</h3>
                  {dateFormat(initialdata.current.issue_date, "mmmm dS, yyyy")}
                </Col>
                {/* <Col span={3}>
                  <h3>Dispatch date</h3>
                  {initialdata.current.dispatch_date
                    ? dateFormat(initialdata.current.dispatch_date, "mmmm dS, yyyy")
                    : "-"}
                </Col> */}
                <Col span={2} style={{ textAlign: "center" }}>
                  <h3>Quantity</h3>
                  {formatter.format(Wallet.current.Quantity)}
                </Col>

                <Col span={2} style={{ textAlign: "center" }}>
                  <h3>Total Bill</h3>
                  {formatter.format(Wallet.current.Bill)}
                </Col>
                <Col span={2} style={{ textAlign: "center" }}>
                  <h3>Payment</h3>
                  {formatter.format(Wallet.current.Payment)}
                </Col>
                <Col span={2} style={{ textAlign: "center" }}>
                  <h3>Due</h3>
                  {formatter.format(Wallet.current.Due)}
                </Col>
                <Col span={2} style={{ textAlign: "center" }}>
                  <h3>Discount</h3>
                  {formatter.format(Wallet.current.Discount)}
                </Col>
                <Col span={2} style={{ textAlign: "center" }}>
                  <h3>VAT</h3>
                  {formatter.format(Wallet.current.VAT)}
                </Col>
                <Col span={3} style={{ textAlign: "center" }}>
                  <h3>Coupon</h3>
                  {Wallet.current.Cupon ? Wallet.current.Cupon.name : "-"}
                </Col>
              </Row>
              <Divider />
              <Row>
                <Col span={8}>
                  <Form
                    form={form}
                    labelCol={{
                      span: 7,
                    }}
                    labelAlign="left"
                    wrapperCol={{
                      span: 16,
                    }}
                    onFinish={onFinish}
                    onValuesChange={handleValuesChange}
                    initialValues={initialdata.current}
                  >
                    <Row gutter={16}>
                      <Col span={24}>
                        <Form.Item
                          name="status"
                          label="Status"
                          rules={[
                            {
                              required: true,
                              message: "Please choose a status",
                            },
                          ]}
                        >
                          <Select
                            placeholder="Please choose a status"
                            style={{ fontWeight: "400" }}
                            onChange={handleStatusChange}
                            open={isStatusOpen}
                            onDropdownVisibleChange={handleStatusDropdownVisibleChange}
                            dropdownMatchSelectWidth={false}
                          >
                            <Option value="Pending">Pending</Option>
                            <Option value="Picked by courier">Picked by courier</Option>

                            {Wallet.current.Due == 0 ? (
                              <>
                                <Option value="Delivered">Delivered</Option>
                                <Option value="Paid">Paid</Option>
                              </>
                            ) : (
                              <></>
                            )}
                            <Option value="Booked">Booked</Option>
                            <Option value="Partial">Partial</Option>
                            <Option value="Exchanged">Exchanged</Option>
                            { (initialdata.current.Location_name === "Main Warehouse" || initialdata.current.Location_name === "Ecommerce") && (!auth || !auth.superuser) ? null : (
                              <Option value="Cancelled">Cancelled</Option>
                            )}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={24}>
                        <Form.Item name="issue_date" label="Issue Date">
                          <DatePicker style={{ width: "100%" }} />
                        </Form.Item>
                      </Col>
                      {(initialdata.current.Location_name === "Main Warehouse" || initialdata.current.Location_name === "Ecommerce") && (!auth || !auth.superuser) ? null : (
                        <>
                          <Divider orientation="left">Dispatch Details</Divider>
                          <Col span={24}>
                            <Form.Item
                              name="dispatch_order"
                              valuePropName="checked"
                              label="Dispatch"
                            >
                              <Checkbox>Dispatch Order</Checkbox>
                            </Form.Item>
                          </Col>
                          <Col span={24}>
                            <Form.Item name="dispatch_date" label="Dispatch Date">
                              <DatePicker disabled style={{ width: "100%" }} />
                            </Form.Item>
                          </Col>

                          <Form.Item
                            noStyle
                            shouldUpdate={(prevValues, currentValues) => prevValues.dispatch_order !== currentValues.dispatch_order}
                          >
                            {({ getFieldValue }) =>
                              getFieldValue('dispatch_order') === true ? (
                                <Col span={24}>
                                  <Row gutter={16} align="middle">
                                    <Col span={24}>
                                      <Form.Item name="DeliveryType" label="Deliv. Method">
                                        <Select placeholder="Select Delivery Method">
                                          {deliverymethod.map(type => (
                                            <Option key={type.id} value={type.id}>{type.name}</Option>
                                          ))}
                                        </Select>
                                      </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                      <Form.Item name="dispatched_by" label="Dispatched By">
                                        <Input placeholder="Dispatched By" readOnly />
                                      </Form.Item>
                                    </Col>
                                    <Col span={6}>
                                      <Button 
                                        type="primary" 
                                        onClick={handleSendSms}
                                        style={{ width: '100%' }}
                                      >
                                        Send SMS
                                      </Button>
                                    </Col>                                
                                  </Row>
                                </Col>
                              ) : null
                            }
                          </Form.Item>
                        </>
                      )}
                      {!Wallet.current.Cupon > 0 ? (
                        <Col span={24}>
                          <small>
                            Max discount:{" "}
                            {formatter.format(Wallet.current.DiscountLimit)} BDT
                          </small>
                          <Form.Item name="discount" label="Sales Disc.">
                            <InputNumber placeholder="Amount" />
                          </Form.Item>
                        </Col>
                      ) : (
                        <Col span={24}>
                          <Form.Item name="discountt" label="Discount">
                            {formatter.format(Wallet.current.Cupon.amount)}
                            {Wallet.current.Cupon.ref_type == "P"
                              ? " %"
                              : " BDT"}
                          </Form.Item>
                        </Col>
                      )}
                      <Col span={24}>
                        <Form.Item
                          name="spec_item_discount"
                          label="Product Disc."
                        >
                          <InputNumber
                            disabled
                            value={totalSpecDiscount}
                            placeholder="Auto-calculated from items"
                            style={{ 
                              fontWeight: "600",
                              color: totalSpecDiscount > 0 ? "#52c41a" : "inherit"
                            }}
                          />
                        </Form.Item>
                        <div style={{ 
                          fontSize: "12px", 
                          color: "#666", 
                          marginTop: "-16px", 
                          marginBottom: "16px",
                          marginLeft: "29%" 
                        }}>
                          Auto-calculated: {formatter.format(totalSpecDiscount)} BDT
                        </div>
                      </Col>
                      {Wallet.current.Advance > 0 ? (
                        <>
                          <Col span={24}>
                            <Form.Item
                              name="advance_payment"
                              label="Advance Payment"
                            >
                              {formatter.format(Wallet.current.Advance)}
                            </Form.Item>
                          </Col>
                        </>
                      ) : (
                        ""
                      )}
                      {Wallet.current.Due > 0 ? (
                        <>
                          <Col span={24}>
                            <Form.Item name="paymentt" label="New Payments">
                              <InputNumber placeholder="Amount" />
                            </Form.Item>
                          </Col>
                        </>
                      ) : (
                        ""
                      )}
                      {Wallet.current.Due > 0 ? (
                        <Col span={24}>
                          <Form.Item name="account" label="Payment Method">
                            <Select>
                              {accounts.map((account) => {
                                return (
                                  <Option key={account.id} value={account.id}>
                                    {account.name}
                                  </Option>
                                );
                              })}
                            </Select>
                          </Form.Item>
                        </Col>
                      ) : (
                        ""
                      )}

                      <Col span={24}>
                        <Form.Item name="Account_no" label="Account No">
                          <Input placeholder="Account No" />
                        </Form.Item>
                      </Col>

                      <Col span={24}>
                        <Form.Item name="Transection_no" label="Transaction No">
                          <Input placeholder="Transaction No" />
                        </Form.Item>
                      </Col>

                      <Col span={24}>
                        <Form.Item
                          name="delivery_charge"
                          label="Delivery Charge"
                          rules={[
                            { required: true, message: "Minimum cost is zero" },
                          ]}
                        >
                          <InputNumber placeholder="Delivery Charge" />
                        </Form.Item>
                      </Col>

                      <Col span={24}>
                        <Form.Item
                          name="shipping_name"
                          label="Shipping Name"
                        >
                          <Input placeholder="Please enter a shipping name" />
                        </Form.Item>
                      </Col>

                      <Col span={24}>
                        <Form.Item
                          name="shipping_phone"
                          label="Shipping Phone"
                        >
                          <Input placeholder="Please enter a shipping phone" />
                        </Form.Item>
                      </Col>

                      <Col span={24}>
                        <Form.Item
                          name="shipping_address"
                          label="Shipping Address"
                        >
                          <Input placeholder="Please enter a shipping address" />
                        </Form.Item>
                      </Col>

                      <Col span={24}>
                        <Form.Item name="remarks" label="Remarks">
                          <ReactQuill theme="snow" preserveWhitespace={true} />
                        </Form.Item>
                      </Col>
                      <Col span={24}>
                        <Form.Item
                          name="is_public"
                          valuePropName="checked"
                          checked
                        >
                          <Checkbox>Active !</Checkbox>
                        </Form.Item>
                      </Col>
                      {auth && auth.superuser && (
                        <Col span={24}>
                          <Form.Item
                            name="is_printable"
                            valuePropName="checked"
                            label="Printable"
                          >
                            <Checkbox>Is Printable</Checkbox>
                          </Form.Item>
                        </Col>
                      )}                     
                    </Row>
                    <Form.Item>
                      <Space>
                        <Button onClick={onClose} style={{ marginRight: 8 }}>
                          Cancel
                        </Button>
                        {initialdata.current.status != "Paid" ? (
                          <Button type="primary" htmlType="submit">
                            Update
                          </Button>
                        ) : (
                          ""
                        )}
                      </Space>
                    </Form.Item>
                  </Form>
                </Col>
                <Col
                  span={9}
                  style={{
                    padding: "30px",
                    paddingTop: "10px",
                    backgroundColor: "whitesmoke",
                    borderRadius: "10px",
                    minHeight: "85vh",
                  }}
                >
                  { (initialdata.current.Location_name === "Main Warehouse" || initialdata.current.Location_name === "Ecommerce") && (!auth || !auth.superuser) ? (
                    <div style={{ pointerEvents: "none", opacity: 0.5 }}>
                      <Addtoupdate
                        wordrobeitems={data}
                        setrefresh={setrefresh}
                        details={initialdata.current}
                      />
                    </div>
                  ) : (
                    <Addtoupdate
                      wordrobeitems={data}
                      setrefresh={setrefresh}
                      details={initialdata.current}
                    />
                  )}
                  {(initialdata.current.Location_name === "Main Warehouse" || initialdata.current.Location_name === "Ecommerce") && (!auth || !auth.superuser) ? (
                    <div style={{ pointerEvents: "none", opacity: 0.5 }}>
                      <Row
                        style={{
                          borderRadius: "5px",
                          padding: "10px",
                        }}
                      >
                        <Col span={1}>
                          <h3></h3>
                        </Col>
                        <Col span={8}>
                          <h3>Details</h3>
                        </Col>
                        <Col span={4}>
                          <h3>Qty</h3>
                        </Col>
                        <Col span={5} offset={1}>
                          <h3>Disc</h3>
                        </Col>
                        <Col span={5} style={{ textAlign: "center" }}>
                          <h3>Price</h3>
                        </Col>
                        <Col span={1}>
                          <h3></h3>
                        </Col>
                      </Row>
                      {renderitems()}
                    </div>
                  ) : (
                    <>
                      <Row
                        style={{
                          borderRadius: "5px",
                          padding: "10px",
                        }}
                      >
                        <Col span={1}>
                          <h3></h3>
                        </Col>
                        <Col span={8}>
                          <h3>Details</h3>
                        </Col>
                        <Col span={4}>
                          <h3>Qty</h3>
                        </Col>
                        <Col span={5} offset={1}>
                          <h3>Disc</h3>
                        </Col>
                        <Col span={5} style={{ textAlign: "center" }}>
                          <h3>Price</h3>
                        </Col>
                        <Col span={1}>
                          <h3></h3>
                        </Col>
                      </Row>
                      {renderitems()}
                    </>
                  )}

                  <Divider />
                  
                </Col>
                <Col span={6} offset={1}>
                  <Log invoiceID={invoice.id} />
                </Col>
              </Row>
            </Col>
          </Row>
        </>
      );
    }
  };
  return (
    <>
      <>
        <a href="#" onClick={showDrawer} style={{ margin: 4 }}>
          Update
        </a>
        <Drawer
          title="Update Invoice"
          width="90%"
          onClose={onClose}
          visible={visible}
        >
          <Spin spinning={fullpageloading}>{renderData()}</Spin>
        </Drawer>
      </>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    courier: state.settings.deliverytype,
    auth: state.auth,
  };
};

export default connect(mapStateToProps, {
  updateInvoice,
  getInvoiceItem,
  getServices,
  updateVariation,
  updateInvoiceItem,
  deleteInvoiceItem,
  getdeliverytype,
  getAllAccount,
  getSpecificInvoice,
  updateService,
  deleteService,
  getInvoiceMeasurement,
  getSpecificMeasurementbycontact,
  sendDispatchSms,
})(Quickview);